import { m } from "./";
export const MotionDiv = m.div;
//# sourceMappingURL=size.js.map